import { entityEffectiveStatusTypes } from '../PerformanceMarketingConstants';

export const catalogEligibleStatus = 'Eligible';

// Catalog campaign statuses: the entity effective statuses plus the "Eligible" pseudo-status
// (a project that qualifies for the program but has no campaign yet).
export const catalogCampaignStatusTypes = {
    active: entityEffectiveStatusTypes.active,
    eligible: catalogEligibleStatus,
    scheduled: entityEffectiveStatusTypes.scheduled,
    completed: entityEffectiveStatusTypes.completed,
    inactive: entityEffectiveStatusTypes.inactive,
};

// Primary sort order: Active → Eligible → Scheduled → Completed → Inactive
export const catalogCampaignStatusSortOrder = {
    [entityEffectiveStatusTypes.active]: 0,
    [catalogEligibleStatus]: 1,
    [entityEffectiveStatusTypes.scheduled]: 2,
    [entityEffectiveStatusTypes.completed]: 3,
    [entityEffectiveStatusTypes.inactive]: 4,
};

export const catalogCampaignStatusDotColor = {
    [entityEffectiveStatusTypes.active]: 'success',
    [entityEffectiveStatusTypes.scheduled]: 'info',
    [entityEffectiveStatusTypes.completed]: 'default',
    [entityEffectiveStatusTypes.inactive]: 'default',
};

export const catalogCampaignStatusLabel = {
    [entityEffectiveStatusTypes.active]: 'Active',
    [catalogEligibleStatus]: 'Eligible',
    [entityEffectiveStatusTypes.scheduled]: 'Scheduled',
    [entityEffectiveStatusTypes.completed]: 'Completed',
    [entityEffectiveStatusTypes.inactive]: 'Inactive',
};

export const catalogCampaignTooltips = {
    overallRevenue: 'The total income generated from your marketing campaign without ad spend or fees.',
    conversionCount: 'Number of backers gained from your ads.',
    disabledEnableButton: 'A catalog campaign can\'t be enabled because you don\'t have permission to manage this project.',
    scheduledStatus: 'This catalog campaign is queued for launch and will start automatically when a campaign slot becomes available.',
};

export const catalogCampaignNameSuffix = ' - Catalog Campaign';

export const catalogCampaignDisableConfirm = {
    title: 'Are you sure?',
    noLabel: 'Cancel',
    business: {
        text: 'Are you sure you want to disable all of your catalog campaigns? This action is permanent and can\'t be undone. '
            + 'Your catalog campaigns can keep running for up to 7 days after disabling and will still add distribution during that time.',
        yesLabel: 'Disable all catalog campaigns',
        actionLabel: 'Disable all catalog campaigns',
    },
    campaign: {
        text: 'Are you sure you want to disable the catalog campaign for this project? This action is permanent and can\'t be undone. '
            + 'The catalog campaign can keep running for up to 7 days after disabling and will still add distribution during that time.',
        yesLabel: 'Disable catalog campaign',
        actionLabel: 'Disable catalog campaign',
    },
};
